import React, { Component } from 'react';
import './WelcomeScreen.css';
import "../../CommonStyles/CSS.css"
//import dvas from '../../images/public/registeration/dvas.png';
//import clos from '../../images/public/registeration/clos.png';
//import back from '../../images/public/registeration/back.png';
import help from '../../images/public/userarea/tab5u.png';
//import crdscia from '../../images/public/userarea/crdscia.png';
//import stck from '../../images/public/login/stck.png';
import logo from '../../images/public/login/logo.png';
//import { element } from 'prop-types';
//import classNames from 'classnames';
//import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
//import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
//import Configminore from '../Configminore/Configminore';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
//import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
//import { addToCart } from '../../libs/fetch'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import Cookies from 'universal-cookie';
//import { Button, Container, Row, Col } from 'react-bootstrap';
// import  { getWorkFlow, modifyWorkflow, workflowState, updateWorkflow, workflowTransition, workflowHelp } from "../../libs/workflow";
import MPWorkFlow from "../../libs/workflow";
//import { HtmlWrapper, fontStyles, getRouteName } from '../../Utils';
import { HtmlWrapper } from '../../Utils';
import InfoModal from "../../assets/components/Modal/Modal";
//import itabar2 from '../../images/public/registeration/nav2i.png';
//import engbar2 from '../../images/public/registeration/nav2e.png';
//import simplebar2 from '../../images/public/registeration/mobilenav2.png';
import skiman from '../../images/public/registeration/skiman.svg';
import TopBar from '../../assets/components/topbar/TopBar';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
import miniArrow from '../../images/public/registeration/miniarrow.png';

const cookies = new Cookies();

class WelcomeScreen extends Component {
	constructor(props) {
		super(props);

		let params = null;
		//console.log('[WelcomeScreen]', params);

		this.state = {
		// isLoading: false,
			step: '2',
			errmsg: null,
			errorFlg: false,
			workFlowInProgress: false, //used by workflow.js services to ensure data avaiability before next screen
			screenData: null,
			userOptions: [],
			canProceed: false,
			helpShow: false,
			helpMessage: "",
		};
	}

	componentDidMount() {
		// this.wf = new MPWorkFlow();
		// this.init();
		// window.gtag('event', 'conversion', {'send_to': 'AW-323718630/aKy1CNvknoQYEOabrpoB'});
		this.refresh();
	}

	async init() {
			// update screenData for current states
			await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Have"));
			this.update();
	}

	async update() {
			// updating server state...
			let resp = await MPWorkFlow.getInstance().workflowState(this, { state_data: this.state.screenData });
			console.log('[WelcomeScreen] @update #resp', resp);
			if (!resp) return;
			if (resp.status === "success") {
					// updating localStorage
					MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
					// updating current screen
					this.refresh();
			} /* else if (resp.status === "fail") {
					this.setState({ canProceed: false, errorFlg: true, errmsg: resp.message });
			} */
	}

	async refresh() {
			// update screenData for current states
			await MPWorkFlow.getInstance().getWorkFlow(this, MPWorkFlow.getInstance().getStageName("Have"));
			this.setState({ canProceed: this.state.screenData.link_next != "" });
			// sorting user's options
			this.orderUserOptions();
	}

	async transit(toWhere) {
    console.log('before workflowTransition 8');
			let resp = await MPWorkFlow.getInstance().workflowTransition(this, { to_state: toWhere });
			//console.log('[WelcomeScreen] @transit #resp', resp);

			if (resp.status === "success") {
					// updating localStorage and navigating to the new screen
					MPWorkFlow.getInstance().updateWorkflow(this,resp.data);
					let nextScreen = MPWorkFlow.getInstance().getRouteName(toWhere);
					// console.log("[WelcomeScreen] @gotoNextStage #getRouteName:", nextScreen);
					return this.props.history.push(nextScreen);
			} /*else if (resp.status === "fail") {
					this.setState({ errorFlg: true, errmsg: resp.message });
			}*/
		}

		alertResponse(info) {
				switch (info.type) {
						case "closeButton":
								this.setState({ errorFlg: false })
								break;
						case "actionButton":
								if (info.option1 === "attention") {
										this.setState({ errorFlg: false })
										break;
								}
				}
		}

		/* new functions for new flow */

		// orders user's options by 'order' key inside 'options' object of screenData
		orderUserOptions() {
				// NOTE: each time an option changes, this function must be called after modifyWorkflow() call
				// order the options
				let options = Object.values(this.state.screenData.options).sort((x, y) => x.order - y.order);
				// console.log("[WelcomeScreen] @orderUserOptions #options:", options);
				this.setState({ userOptions: options });
		}

		onUserOptionChanged = (id) => {
				let index = Number(id.split("-")[2]);
				// console.log("[WelcomeScreen] @onUserOptionChanged #index:", index);
				// finding corresponding key in the object that matches the order index 
				let options = this.state.userOptions;
				// console.log("[WelcomeScreen] @onUserOptionChanged #options:", options);
				let workflowOptions = this.state.screenData.options;
				// console.log("[WelcomeScreen] @onUserOptionChanged #workflowOptions:", workflowOptions);
				const key = Object.keys(workflowOptions).find(key => workflowOptions[key].order === options[index].order);
				// console.log("[WelcomeScreen] @onUserOptionChanged #key:", key);
				// changing options and modifying workflow
				// clearing all options and setting the selected one
				options.map(opt => {  // for current screen usage
						opt.enabled = 0;
				});
				// to update the workflow
				Object.keys(workflowOptions).map(k => { // for updating the complete w.f.
						workflowOptions[k].enabled = 0;
				})
				// setting the selected option
				options[index].enabled = 1;
				workflowOptions[key].enabled = 1;
				// console.log("[WelcomeScreen] @onUserOptionChanged #workflowOptions:", workflowOptions);
				// console.log("[WelcomeScreen] @onUserOptionChanged #options:", options);
				// update current screen
				this.setState({ userOptions: options });
				// updating wf
				let screenData = this.state.screenData;
				screenData.options = workflowOptions;
				// // console.log("[WelcomeScreen] @onUserOptionChanged #screenData:", screenData);
				// modifyWorkflow(this, stageName, screenData);
				this.update();
		}

		gotoNextStage = (e) => {
				e.preventDefault();
				this.transit(this.state.screenData.link_next);
		}

		helpShowModal = (help_tag) => {
				MPWorkFlow.getInstance().workflowHelp(this, {tag: help_tag});
		}

		onBack = () => {
				//return this.props.history.push('/');
				this.transit(this.state.screenData.link_back);
		}

		render() {
			return (
				<Router>
					<div>
						<div>
							<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
								<div className="row flex-nowrap">
									<div className="col-2 d-flex align-items-center">
										<button className="sn_btnbox" onClick={ this.onBack }><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
									</div>
									<div className="col-8 d-flex align-items-center justify-content-center">
										<img className="sn_mobile_top_row_logo" src={ logo } />
									</div>
									<div className="col-2 d-flex align-items-center justify-content-end">
										<button className="sn_btnbox" onClick={() => this.helpShowModal(this.state.screenData.help_tag)}><img className="sn_mobile_top_row_quest" src={ help }/></button>
									</div>
								</div>
							</div>
							<div className="sn_topbar"><TopBar step={ this.state.step }/></div>
							<div className="sn_overlay d-lg-none"></div>
							<div className="sn_welcome">
								<div className="container">
									<div className="row flex-column">
										<div className="col-12 col-lg-10 mx-auto d-flex justify-content-center">
											<div className="sn_hiddenContainer">
												<div className="sn_skiman d-none d-lg-flex">
													<img src={ skiman } />
												</div>
											</div>
										</div>
										<div className="col-12 col-lg-10 mx-auto position-relative">
											<div className="sn_register__container pr-3 pr-lg-4">
												<div className="row">
													<div className="col-3 d-none d-lg-block">
														<div className="big_arrow_wrap">
															<div className="big_arrow"></div>
														</div>
													</div>
													<div className="col-12 col-lg-9">
														<div className="row mb-3 d-none d-lg-flex">
															<div className="col-12 col-lg d-flex justify-content-between mb-4 mb-lg-0 mt-3 mt-lg-0">
																<div className="sn_welcome__container__logoTitle mr-auto mr-lg-0">
																	<img src={ logo }/>
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col-12 d-flex flex-column align-items-center align-items-lg-start mb-3">
																<h3 className="text-center text-lg-left">{ this.state.screenData && HtmlWrapper(this.state.screenData.title) }</h3>
																<div className="sn_skiman d-flex d-lg-none mb-2">
																	<img src={ skiman } />
																</div>
																<p className="mb-4">{ this.state.screenData && HtmlWrapper(this.state.screenData.desc) }</p>
																{
																	this.state.userOptions.map((option, index) => {
																		return <UserOptions
																			key={`user-option-key-${index}`}
																			id={`user-option-${index}`}
																			option={option}
																			onChange={this.onUserOptionChanged}
																	/>
																	})
																}
															</div>
															<div className="col-12 col-lg-10 d-flex align-items-center align-items-lg-end flex-column">
																<div className="row mb-4">
																	<div className="col-12 d-flex flex-column flex-column-reverse align-items-center flex-sm-row justify-content-end">
																		<button className="sn_btn mr-sm-3 d-none d-lg-block" onClick={ this.onBack }>{ tr.t('back') }</button>
																		<button disabled={!this.state.canProceed} className="sn_btn mb-3 mb-sm-0" onClick={this.gotoNextStage}>{this.state.screenData && this.state.screenData.next_button}</button>
																	</div>
																</div>
																<p className="text-center text-lg-right mb-1">{(tr.t("Later"))}</p>
																<h6 className="sn_underline">
																	<a onClick={() => { this.transit(this.state.screenData.link_exit); }}>
																		{(tr.t("Goto"))}
																	</a>
																</h6>
															</div>
															<div className="col-2 d-none d-lg-flex justify-content-center align-items-end">
																<div className="sn_quest">
																	<a onClick={() => this.helpShowModal(this.state.screenData.help_tag)}>
																		<img src={ help } />
																	</a>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="row d-lg-none mt-5">
													<div className="col-12">
														<ProgressBullets step={ this.state.step } />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							{
								this.state.errorFlg ?
									<div className="containerModal">
									{
										this.state.errorFlg ?
										<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
									}
								</div> : null
							}
							</div>
							<WaitLoad enable={this.state.workFlowInProgress} />
						{this.state.helpShow && <InfoModal info={this.state.helpMessage} show={true} onClose={() => this.setState({ helpShow: false })} />}
					</div>
				</Router>
			);
		}
}

export default WelcomeScreen;

class UserOptions extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			refresh: true,
		}
		this.myRef = React.createRef();
	}

	onChange = (e) => {
		this.props.onChange(this.props.id);
	}

	render() {
		return (
			<div onClick={this.onChange} className="sn_user-option-container">
				<div className="circle-base-outlined sn_abs">
					{ this.props.option.enabled == 1 && <div className="circle-base-inside" />}
				</div>
				<div className="spaceIn">
					{ HtmlWrapper(this.props.option.title)}
					{ HtmlWrapper(this.props.option.desc)}
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/WelcomeScreen/WelcomeScreen.js